import { render, staticRenderFns } from "./temWaterAlarmDetail.vue?vue&type=template&id=f23ba560&scoped=true"
import script from "./temWaterAlarmDetail.vue?vue&type=script&lang=js"
export * from "./temWaterAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./temWaterAlarmDetail.vue?vue&type=style&index=0&id=f23ba560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23ba560",
  null
  
)

export default component.exports